import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { generateBaseURL } from '../axios.config'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

export const botApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: generateBaseURL(7777, 'https'),
    prepareHeaders: headers => {
      const token = cookies.get('TOKEN')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  reducerPath: 'botApi',
  tagTypes: [],
  endpoints: () => ({}),
})
